import { WHITE, GRAY_300, ERROR_600, GRAY_500 } from "../../../constant/colors";

export const ModalStyle = `
.ant-modal-content{
    border-radius: 12px;
    padding-bottom: 11px;
    .ant-btn-default{
        background-color: ${WHITE};
        border: 1px solid ${GRAY_300};
        box-shadow: 0px 1px 2px 0px #1018280d;
        font-weight: 600;
        font-size: 16px;
    }
    .ant-btn-primary{
        background-color: ${ERROR_600};
        border: 1px solid ${ERROR_600};
        box-shadow: 0px 1px 2px 0px #1018280d;
        border-radius: 4px;
        font-weight: 600;
        font-size: 16px;
    }
    .title {
        font-weight: 600;
        font-size: 18px;
    }
    .content {
        color: ${GRAY_500};
    }
    .ant-btn {
        padding: 10px 16px 10px 16px;
        height: auto;
        border-radius: 4px;
    }      
    .ant-modal-close {
        .ant-modal-close-x {
          display: none !important;
        }
      }
}
.ant-modal-body{
    padding-bottom: 10px;
}
.ant-modal-footer{
    border: 0;
}
.ant-modal-mask {
    background: #00000099;
  }
`;
